import { environment } from '@environments/environment';



let localhost = {
	url: "http://localhost:3700/api/",
	url_user: "http://localhost:3700/api-users/",
	url_auth: 'http://localhost:3700/api-auth/',
	url_certpro: 'http://localhost:3700/api-certpro/',
	url_api_auth: 'https://api-auth.adventistas.cl/api-auth/',
	version: "1.1.0.18"
}

let dev = {
	url:  'https://api-auditoria-dev.adventistas.cl/api/',
	url_user: "https://api-auditoria-dev.adventistas.cl/api-users/",
	url_auth: 'https://api-auditoria-dev.adventistas.cl/api-auth/',
	url_certpro: 'https://api-auditoria-dev.adventistas.cl/api-certpro/',
	url_api_auth: 'https://api-auth.adventistas.cl/api-auth/',
	version: "1.1.0.18"
}

let test = {
	url: 'https://api-auditoria-staging.adventistas.cl/api/', 
	url_user: "https://api-auditoria-staging.adventistas.cl/api-users/",
	url_auth: 'https://api-auditoria-staging.adventistas.cl/api-auth/',
	url_certpro: 'https://api-auditoria-staging.adventistas.cl/api-certpro/',
	url_api_auth: 'https://api-auth.adventistas.cl/api-auth/',
	version: "1.1.0.18"
}

let prod = {
	url: 'https://api-auditoria.adventistas.cl/api/', 
	url_user: "https://api-auditoria.adventistas.cl/api-users/",
	url_auth: 'https://api-auditoria.adventistas.cl/api-auth/',
	url_certpro: 'https://api-auditoria.adventistas.cl/api-certpro/',
	url_api_auth: 'https://api-auth.adventistas.cl/api-auth/',
	version: "1.1.0.18"
}

export var Global = environment.env == 'Staging' ? test : (environment.env== 'Production'?prod:(environment.env== 'Development'?dev:localhost))
